import React, { FunctionComponent } from "react"

interface IGridItemProps extends React.HTMLAttributes<HTMLDivElement> {
    area?: React.CSSProperties["gridArea"]
    column?: React.CSSProperties["gridColumn"]
    /**
     * Aligns a grid item inside a cell along the inline (row) axis.
     * This value applies to a grid item inside a single cell.
     **/
    justifySelf?: React.CSSProperties["justifySelf"]
    /**
     * Aligns a grid item inside a cell along the block (column) axis.
     * This value applies to the content inside a single grid item.
     **/
    alignSelf?: React.CSSProperties["alignSelf"]
}

const GridItem: FunctionComponent<React.PropsWithChildren<IGridItemProps>> = ({
    area,
    column,
    justifySelf,
    alignSelf,
    children,
    ...others
}) => {
    if (area && column) {
        throw new Error("Cannot pass both `area` and `column` props to the GridItem component.")
    }

    const style: React.CSSProperties = {
        justifySelf,
        alignSelf,
    }

    if (area) {
        style.gridArea = area
    }

    if (column) {
        style.gridColumn = column
    }

    return (
        <div style={style}
            {...others}>
            {children}
        </div>
    )
}

export default GridItem
